import React from "react";
import "./Maintenance.css";
const TitilMaintenance = () => {
  return (
    <>
      <div className="hardware-container">
        <div className="content">
          <h2 className="heading">Maintenance Services</h2>
          <p className="description">
            <>
              Proscope provides comprehensive IT maintenance services to ensure
              your systems run reliably, securely, and with minimal downtime.
              Our services are designed to support critical IT infrastructure,
              endpoint devices, and core applications in a way that minimizes
              risk and maximizes performance.
              <br />
              <br />
              We offer both Troubleshooting and proactive maintenance, including
              system monitoring, updates, troubleshooting, and hardware health
              checks. Whether you need on-site support, remote assistance, or
              SLA-based service contracts — we tailor packages to suit your
              needs.
              <br />
              <br />
              We also provide hardware spare parts and device replacements as
              part of our service options — minimizing downtime and enabling
              seamless system recovery when needed.
              <br />
              <br />
              Choose from flexible support levels — from basic remote assistance
              to fully managed SLA-based service with onsite support, reporting,
              and dedicated account handling.
              <br />
              <br />
              Let us take care of your IT backbone, so you can focus on growth,
              innovation, and delivering value to your customers.
            </>
          </p>
        </div>
        <div className="maintenance-container">
          <div className="content">
            <h2 className="service-heading">
              Support Center - Maintenance Services
            </h2>
            <table className="service-table">
              <thead>
                <tr>
                  <th>Service Features</th>
                  <th>Basic Support</th>
                  <th>Standard Support</th>
                  <th>Premium SLA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Business Hour Support (Mon-Fri)</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>On-site Support</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>Remote Troubleshooting</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>Proactive System Monitoring</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>Scheduled Health Checks</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>Patch Management & Auto Updates</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>Performance Reporting</td>
                  <td className="support-no">✘</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>SLA Response Time</td>
                  <td className="support-no2">N/A</td>
                  <td className="support-no2">8 hrs</td>
                  <td className="support-no2">4 hrs</td>
                </tr>
                <tr>
                  <td>Hardware Spare Part Provisioning</td>
                  <td className="support-no">✘</td>
                  <td className="support-no2">Optional</td>
                  <td className="support-yes">✓</td>
                </tr>
                <tr>
                  <td>Dedicated Account Manager</td>
                  <td className="support-no">✘</td>
                  <td className="support-no">✘</td>
                  <td className="support-yes">✓</td>
                </tr>
              </tbody>
            </table>
            <p className="addons-info">
              Optional add-ons available: Backup appliances, disaster recovery
              simulation, and extended warranty support.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TitilMaintenance;

